import { A11Y_MIN_SIZE, DEFAULT_LINE_HEIGHT, EM_TO_PX_RATIO } from "./constants";
import { getContentHeight } from "./utils";
export var getAccessibilityPadding = function getAccessibilityPadding(lineHeight, fontSize) {
  var contentHeight = !fontSize || fontSize === '' ? EM_TO_PX_RATIO * DEFAULT_LINE_HEIGHT : getContentHeight(lineHeight, fontSize);
  return Math.ceil((A11Y_MIN_SIZE - contentHeight) / 2);
};